import { render, staticRenderFns } from "./22.vue?vue&type=template&id=f2a1fa00&scoped=true&"
var script = {}
import style0 from "./22.vue?vue&type=style&index=0&id=f2a1fa00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a1fa00",
  null
  
)

export default component.exports